import React, { useEffect, FC, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Button, message, Space, Modal, Radio } from "antd";
import type { RadioChangeEvent } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  StarFilled,
  StarTwoTone,
  ShareAltOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import Evaluation from "@/components/evaluation";
import VedioImg from "@/vedio.png";
import "./subject.less";
import axios from "@/axios/axios";
const svgFontStyle = {
  fontSize: "30px",
};
let waitPayStatus: string | number | NodeJS.Timeout | null | undefined = null;
const Subject: FC<any> = ({ location, match, storeData }) => {
  const from = storeData.from || {};
  const history = useHistory();
  const { userInfo } = storeData;
  // 课程信息
  const [course, setCourse] = useState({} as any);
  const [sectionList, setSectionList] = useState([]);
  const [teacherInfo, setTeacherInfo] = useState({} as any);
  const [evaluateOpen, setEvaluateOpen] = useState(false);
  const [apparise, setApparise] = useState<any>({});
  const [recommandList, setRecommandList] = useState([]);
  const [itemCollectFlag, setItemCollectFlag] = useState(0);
  const [shareCode, setShareCode] = useState("");
  const [payCode, setPayCode] = useState("");
  const [payStatus, setPayStatus] = useState({
    /**是否需要支付 */
    needPay: 0,
    /**价格 */
    price: 0,
    /**学时 */
    quantity: 0,
    /**产品名称 */
    productName: "",
    /**默认微信支付 */
    type: 1,
    /**产品ID */
    productId: "",
    /**支付金额 */
    orderAmount: 0,
    /**是否已购买 */
    itemPurchasedFlag: 0,
    /**购买模式 */
    chargeMode: 1,
  });
  const [payType, setPayType] = useState(1);
  const [showPayModal, setShowPayModal] = useState(false);
  const getCourse = async () => {
    if (!userInfo) {
      message.info("请先登录");
      history.push("/index/home");
      return;
    }
    const id = match.params.id;
    const {
      code,
      data: {
        data: {
          item,
          itemTeacher,
          sectionList,
          itemUserAppraise,
          recommendItemList = [],
          itemCollectFlag = 0,
        },
      },
      msg,
    }: any = await axios.post(`/shop/front/ce/item/${id}/info`);
    if (code === 0) {
      setCourse(item);
      setSectionList(sectionList || []);
      setTeacherInfo(itemTeacher);
      setApparise(itemUserAppraise || {});
      setRecommandList(recommendItemList);
      setItemCollectFlag(itemCollectFlag);
      const { itemPurchasedFlag, itemSalePrice, chargeMode } = item;
      setPayStatus({
        ...payStatus,
        needPay: itemPurchasedFlag,
        price: itemSalePrice,
        chargeMode,
      });
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    getCourse();
  }, []);

  const jump = (data: any) => {
    history.push({ pathname: `/play/${data.itemId}/${data.id}` });
  };

  const [visible, setVisible] = useState<boolean>(false);

  // 获取评价信息
  const [evaluate, setEvaluate] = useState({} as any);
  const getEvaluate = async (params: any) => {
    const { code, data, msg }: any = await axios.post(
      `/shop/courseUserRating/queryOne`,
      { courseId: params?.courseId }
    );
    if (code === 0) {
      setEvaluate(data || {});
      setVisible(true);
    } else {
      message.error(msg);
    }
  };

  // 提交评价信息
  const submit = async (val: number, text: any) => {
    const id = match.params.id;
    const params = {
      content: text,
      itemId: id,
      starLevel: val,
    };
    const { code, data, msg }: any = await axios.post(
      `/shop/front/ce/item/user/appraise/save`,
      params
    );
    if (code === 0) {
      message.success("评价成功");
      setEvaluateOpen(false);
      getCourse();
    } else {
      message.error(msg);
    }
  };
  /**
   * 解除项目收藏
   */
  const cancelProjectCollection = async () => {
    const id = match.params.id;
    const { code, data, msg }: any = await axios.post(
      `/shop/front/ce/item/${id}/user/collect/cancel`,
      {}
    );
    getCourse();
  };
  /**
   * 保存项目收藏
   */
  const saveProjectCollection = async () => {
    const id = match.params.id;
    const { code, data, msg }: any = await axios.post(
      `/shop/front/ce/item/${id}/user/collect/save`,
      {}
    );
    getCourse();
  };
  /**
   * 项目分享
   */
  const shareImg = async () => {
    const id = match.params.id;
    const { data } = await axios.post(
      `/shop/front/ce/item/${id}/share/code`,
      {}
    );
    setShareCode(data);
  };
  /**
   * 获取支付信息
   */
  const getPayInfo = async () => {
    const id = match.params.id;
    const {
      data: { quantity, productName, productId, orderAmount },
    } = await axios.post(`/shop/front/ce/preview/item/${id}/order/info`, {});
    setPayStatus({
      ...payStatus,
      quantity,
      productName,
      productId,
      orderAmount,
    });
    setShowPayModal(true);
  };
  const payTypeChange = (e: RadioChangeEvent) => {
    setPayType(e.target.value);
  };
  /**
   * 支付宝支付
   */
  const payAliOrder = async () => {
    const itemId = Number(match.params.id);
    const { productId, quantity } = payStatus;
    const { data } = await axios.post(
      "/shop/front/ce/pc/create/ali/pay/order",
      {
        productId,
        quantity,
        itemId,
      }
    );
    const { orderNo } = data;
    const returnUrl = encodeURIComponent(
      `${window.location.href}?currentPayTradeNo=${orderNo}`
    );
    window.location.href = `https://api.imed.org.cn/order/createAliPayOrder?payType=ALI_PAY&tradeNo=${orderNo}&returnUrl=${returnUrl}&tradeType=NATIVE`;
  };
  /**
   * 微信支付
   */
  const payWechatOrder = async () => {
    const itemId = Number(match.params.id);
    const { productId, quantity } = payStatus;
    const { data } = await axios.post(
      "/shop/front/ce/pc/create/wetChat/pay/order",
      {
        productId,
        quantity,
        itemId,
      }
    );
    const { tradeNo, weChatPayQrCode } = data;
    setPayCode(weChatPayQrCode);
    searchWechatPayStatus(tradeNo);
    setShowPayModal(false);
  };
  /**查询微信支付状态 */
  const searchWechatPayStatus = (tradeNo: string) => {
    waitPayStatus = setInterval(async () => {
      const {
        data: { code },
      } = await axios.post(`/shop/front/ce/order/${tradeNo}/pay/status`);
      if (code === 0) {
        clearInterval(waitPayStatus as number);
        setPayCode("");
        // 订单列表重定向查询
        window.location.href = `${window.location.href}?fromType=wechatPay`;
        window.location.reload();
      }
    }, 3000);
  };
  return (
    <div
      className={"subject"}
      onClick={() => {
        setShareCode("");
      }}
    >
      <div className={"cover"}>
        <div className="content">
          <div className={"img-box"}>
            <img src={course.imageAllPath} alt="" />
          </div>
          <div className={"cover-text"}>
            <h2>{course.itemName}</h2>
            <p>学分类别：{course.creditInfo}</p>
            <p>项目编号：{course.itemCode}</p>
            <p>项目负责人：{teacherInfo.name}</p>
            <p>单位：{teacherInfo.workUnit}</p>
            <Space>
              {!apparise.starLevel ? (
                <Button
                  type="primary"
                  onClick={() => {
                    setEvaluateOpen(true);
                  }}
                >
                  项目评价
                </Button>
              ) : (
                <Button
                  type="primary"
                  style={{ background: "#999", borderColor: "#999" }}
                >
                  已评价
                </Button>
              )}
              {payStatus.chargeMode === 2 && (
                <span>
                  {payStatus.needPay === 0 && (
                    <Button
                      type="primary"
                      onClick={getPayInfo}
                      style={{
                        background: "red",
                        borderColor: "red",
                      }}
                    >
                      <span>¥{payStatus.price}</span>
                    </Button>
                  )}
                  {payStatus.needPay === 1 && (
                    <Button type="primary">已购买</Button>
                  )}
                </span>
              )}
            </Space>
            <Evaluation
              open={evaluateOpen}
              onCancel={() => setEvaluateOpen(false)}
              submit={({ star, text }) => {
                submit(star, text);
              }}
            ></Evaluation>
            <p style={{ textAlign: "right", position: "relative" }}></p>
          </div>
          <div className="collection-box">
            {itemCollectFlag === 1 ? (
              <StarFilled
                style={{ ...svgFontStyle, color: "orange" }}
                onClick={() => {
                  cancelProjectCollection();
                }}
              />
            ) : (
              <StarTwoTone
                style={{
                  ...svgFontStyle,
                }}
                onClick={() => {
                  saveProjectCollection();
                }}
              />
            )}
            <span className="share-icon-container">
              <ShareAltOutlined
                onClick={() => {
                  shareImg();
                }}
                style={{
                  color: "orange",
                  ...svgFontStyle,
                }}
              />
              {shareCode && (
                <div className="share-img">
                  <img src={shareCode} alt="" />
                  <p>
                    <span>手机扫码观看/分享</span>
                  </p>
                </div>
              )}
            </span>
          </div>
        </div>
      </div>
      <div className="catalog-container">
        <div
          style={{
            width: "100%",
          }}
        >
          {course.introduction && (
            <div className={"catalog-title"}>
              <div className={"title"}>项目介绍</div>
              <div
                dangerouslySetInnerHTML={{ __html: course.introduction }}
              ></div>
            </div>
          )}
          {sectionList.length > 0 && (
            <div className={"catalog"}>
              <div className={"title"}>课件列表</div>
              {sectionList.map((section: any, i: number) => (
                <div key={i} className={"content"}>
                  {i === 0 && (
                    <small style={{ color: "red" }}>
                      注：全部学完并通过考试才能申请学分
                    </small>
                  )}
                  <h3>{section.name}</h3>
                  <ul className={"subject-items"}>
                    <li key={i}>
                      <div className={"img-box"}>
                        <img src={VedioImg} alt="" />
                      </div>
                      <div className={"info-box"}>
                        <h3>{section.sectionName}</h3>
                        <div className={"info"}>
                          <div>
                            <div style={{ display: "flex" }}>
                              <div>
                                主讲人：{section.itemTeacher.name}
                                <br />
                                <p>
                                  学习状态：
                                  {section.watchStatus === 1
                                    ? "已学完"
                                    : "未学完"}
                                </p>
                              </div>
                              <div style={{ marginLeft: "20px" }}>
                                主讲人单位：{section.itemTeacher.workUnit}
                                <br />
                                <span>考试状态：{section.examStatusText}</span>
                              </div>
                            </div>
                            <Button
                              style={{ marginRight: "10px", float: "right" }}
                              onClick={() => {
                                jump(section);
                              }}
                              type="primary"
                              size="small"
                              shape="round"
                            >
                              播放
                            </Button>
                            <p className="status-content"></p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
        {recommandList.length > 0 && (
          <div className="recommandList">
            <h3>推荐项目</h3>
            {recommandList.map((item: any) => (
              <div
                className="recommand-item"
                onClick={() => {
                  history.push({ pathname: `/index/subject/${item.id}` });
                  window.location.reload();
                }}
              >
                <p>
                  <img src={item.imageAllPath} alt="" />
                </p>
                <div className="right">
                  <h3>{item.itemName}</h3>
                  <p>项目负责人：{item.itemLeaderName}</p>
                  <p>学分：{item.creditInfo}</p>
                  <p>编号：{item.itemCode}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Modal
        title="确认订单"
        open={showPayModal}
        onOk={() => {
          payType === 1 ? payWechatOrder() : payAliOrder();
        }}
        onCancel={() => {
          setShowPayModal(false);
        }}
      >
        <h3>{payStatus.productName}</h3>
        <p>学时：{payStatus.quantity}</p>
        <p>订单金额：¥{payStatus.orderAmount}</p>
        <p>
          <Radio.Group onChange={payTypeChange} value={payType}>
            <Radio value={1}>微信支付</Radio>
            <Radio value={2}>支付宝支付</Radio>
          </Radio.Group>
        </p>
      </Modal>
      {payCode && (
        <div className="weChatPayModal">
          <p
            onClick={() => {
              clearInterval(waitPayStatus as number);
              setPayCode("");
            }}
            className="back"
          >
            <Space>
              <ArrowLeftOutlined />
              返回
            </Space>
          </p>
          <div className="content">
            <h3>微信支付</h3>
            <p>请扫描二维码付款</p>
            <p>¥&nbsp;{payStatus.orderAmount}</p>
            <img src={payCode} alt="" />
          </div>
        </div>
      )}
    </div>
  );
};

export default connect((state) => state)(Subject);
